import { createAsyncThunk } from '@reduxjs/toolkit';

import { getErrorMessage } from '@/shared/utils/error';
import type {
  CategoriaFilters,
  CreateCategoriaDto,
  UpdateCategoriaDto,
} from '@/types/categoria/categoriaTypes';

import { categoriaService } from './services';

export const listarCategorias = createAsyncThunk(
  'categoria/listar',
  async (filters: CategoriaFilters | undefined, { rejectWithValue }) => {
    try {
      return await categoriaService.listar(filters);
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  },
);

export const buscarCategoriaPorId = createAsyncThunk(
  'categoria/buscarPorId',
  async (id: string, { rejectWithValue }) => {
    try {
      return await categoriaService.buscarPorId(id);
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  },
);

export const criarCategoria = createAsyncThunk(
  'categoria/criar',
  async (data: CreateCategoriaDto, { rejectWithValue }) => {
    try {
      return await categoriaService.criar(data);
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  },
);

export const atualizarCategoria = createAsyncThunk(
  'categoria/atualizar',
  async ({ id, data }: { id: string; data: UpdateCategoriaDto }, { rejectWithValue }) => {
    try {
      return await categoriaService.atualizar(id, data);
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  },
);

export const excluirCategoria = createAsyncThunk(
  'categoria/excluir',
  async (id: string, { rejectWithValue }) => {
    try {
      await categoriaService.excluir(id);
      return id;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  },
);

export const excluirCategoriaComOpcoes = createAsyncThunk(
  'categoria/excluirComOpcoes',
  async (
    {
      id,
      moveSubcategoriasToParent,
      removeExecucoesLink,
    }: {
      id: string;
      moveSubcategoriasToParent: boolean;
      removeExecucoesLink: boolean;
    },
    { rejectWithValue },
  ) => {
    try {
      await categoriaService.excluir(id);
      return { id, moveSubcategoriasToParent, removeExecucoesLink };
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  },
);

export const buscarCategoria = buscarCategoriaPorId;

export const buscarEstatisticasCategoria = createAsyncThunk(
  'categoria/buscarEstatisticas',
  async (id: string, { rejectWithValue }) => {
    try {
      return await categoriaService.buscarEstatisticas(id);
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  },
);

export const buscarTimelineCategoria = createAsyncThunk(
  'categoria/buscarTimeline',
  async (
    {
      id,
      filters,
    }: { id: string; filters?: { page?: number; limit?: number; tipoEvento?: string } },
    { rejectWithValue },
  ) => {
    try {
      return await categoriaService.buscarTimeline(id, filters);
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  },
);
